import { defaultIconProps, IconProps } from './IconProps';

export const IconPuzzle: import('react').FC<IconProps> = ({ size, color, strokeWidth = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_10989_22821)">
      <path
        d="M6.25033 3.74984C6.25033 2.59924 7.18307 1.6665 8.33366 1.6665C9.48425 1.6665 10.417 2.59924 10.417 3.74984V4.99984H11.2503C12.4152 4.99984 12.9976 4.99984 13.457 5.19014C14.0696 5.44387 14.5563 5.93056 14.81 6.54313C15.0003 7.00256 15.0003 7.58498 15.0003 8.74984H16.2503C17.4009 8.74984 18.3337 9.68258 18.3337 10.8332C18.3337 11.9838 17.4009 12.9165 16.2503 12.9165H15.0003V14.3332C15.0003 15.7333 15.0003 16.4334 14.7278 16.9681C14.4882 17.4386 14.1057 17.821 13.6353 18.0607C13.1005 18.3332 12.4005 18.3332 11.0003 18.3332H10.417V16.8748C10.417 15.8393 9.57753 14.9998 8.54199 14.9998C7.50646 14.9998 6.66699 15.8393 6.66699 16.8748V18.3332H5.66699C4.26686 18.3332 3.5668 18.3332 3.03202 18.0607C2.56161 17.821 2.17916 17.4386 1.93948 16.9681C1.66699 16.4334 1.66699 15.7333 1.66699 14.3332V12.9165H2.91699C4.06759 12.9165 5.00033 11.9838 5.00033 10.8332C5.00033 9.68258 4.06759 8.74984 2.91699 8.74984H1.66699C1.66699 7.58498 1.66699 7.00256 1.85729 6.54313C2.11103 5.93056 2.59771 5.44387 3.21028 5.19014C3.66971 4.99984 4.25214 4.99984 5.41699 4.99984H6.25033V3.74984Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10989_22821">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

IconPuzzle.defaultProps = defaultIconProps;
